import { c as _c } from "react-compiler-runtime";
import { useCallback } from 'react';
import { useSelectionDispatch, useSelectionSelector } from '../../redux/reduxHooks';
import { clearSelection, getIsQuerySelected, selectQuery } from '../redux/selectionSlice';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectQueryRow = t0 => {
  const $ = _c(16);
  const {
    rowIds,
    columnCount,
    totalRowCount,
    CustomSelectAllComponent
  } = t0;
  const dispatch = useSelectionDispatch();
  const isQuerySelected = useSelectionSelector(getIsQuerySelected);
  let t1;
  if ($[0] !== dispatch) {
    t1 = () => dispatch(selectQuery());
    $[0] = dispatch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectEverything = t1;
  let t2;
  if ($[2] !== dispatch) {
    t2 = () => dispatch(clearSelection());
    $[2] = dispatch;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const clearAllSelections = t2;
  let t3;
  if ($[4] !== CustomSelectAllComponent || $[5] !== clearAllSelections || $[6] !== isQuerySelected || $[7] !== rowIds || $[8] !== selectEverything || $[9] !== totalRowCount) {
    t3 = /*#__PURE__*/_jsx("td", {
      "data-cell-type": "select-query",
      children: /*#__PURE__*/_jsx(Text, {
        as: "small",
        paddingInlineStart: "1700",
        children: isQuerySelected ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            useGap: true,
            message: "datatable.bulkActions.querySelected",
            options: {
              count: totalRowCount
            }
          }), /*#__PURE__*/_jsx(Button, {
            "data-test-id": "clear-selection-button",
            use: "link",
            onClick: clearAllSelections,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "datatable.bulkActions.clearSelection"
            })
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            useGap: true,
            message: "datatable.bulkActions.pageSelected",
            options: {
              count: rowIds.length
            }
          }), /*#__PURE__*/_jsx(CustomSelectAllComponent, {
            selectEverything: selectEverything,
            totalRowCount: totalRowCount
          })]
        })
      })
    });
    $[4] = CustomSelectAllComponent;
    $[5] = clearAllSelections;
    $[6] = isQuerySelected;
    $[7] = rowIds;
    $[8] = selectEverything;
    $[9] = totalRowCount;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = columnCount - 1;
  let t5;
  if ($[11] !== t4) {
    t5 = /*#__PURE__*/_jsx("td", {
      colSpan: t4
    });
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t3 || $[14] !== t5) {
    t6 = /*#__PURE__*/_jsxs("tr", {
      "data-row-type": "select-query-row",
      "data-test-id": "select-query-row",
      children: [t3, t5]
    });
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default SelectQueryRow;